module.exports = __webpack_public_path__ + "ci_webhook.7cc23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_webhook.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_webhook.svg
// module chunks = main